export const users = {
	en: {
        nav: {
            title: 'Users',
            titleC: "Clients",
            searchBox: "Search client",
            dashboard: 'Dashboard',
            text: "To view your data, first select a month from the side menu",
            empty: "No devices registered"
        },
        tabs: [
            'Dashboard',
            'General', 
            'Web', 
            'Mobile',
            'Paths'
        ],
		table: {
            title: ['Web connections',"Mobile connections"],
            columns: [
                'Date',
				'Mexico',
                'USA',
                'Colombia',
                'Count',
            ],
            pager: ['Page', 'of', 'Row(s) per page'],
            text:["You have reached the first page","You have reached the last page"],
            noDevice: "No registered connections"
        },
        graphs:{
            line:{
                axis: ["Date","Connections"],
            },
            pie:{
                title: ["Devices", "Countries"],
                devices: ["Web", "Mobile"],
                countries: ["Mexico","Usa"],
            },
            prefix: ["Day ", " clientes connected: ", "Devices connected in "],
            modal:{
                xlabels: [
                    "Realtime",
                    "History",
                    "Reports",
                    "Geofences",
                    "Maintenance",
                    "Admin",
                    "Routes",
                    "Cameras",
                ],
                prefix: [" was visited ", " time ", " by:", " times"],
                text: "To view your data, first select a client from the side menu",
                axis: ["Frequently views", "Frequency", "Modules"],
                modalMtto:[
                    "Dashboard",
					"Service Log",
					"Error Codes",
                ],
                modalAdmin:[
                    "Devices",
                    "Users",
                    "Permissions",
                    "Groups",
                    "Drivers",
                    "Links",
                    "Alerts",
                    "Integrations"
                ],
                modalCamera:[
                    "Camera",
					"Live"
                ],
            }
        },
        sidebar:["Connections", "Search", "Select a month", "You must select a month"],
        modal:{
            title: "Clients details",
            columns: [
                'Clients',
                'Users connections',
                'Users'
            ],
        },
        login: {
            username: "Username",
            password: "Password",
            button: "Login"
        },
        auxHcBar:{
            namesGeneral: [
                "Realtime", 
                "History", 
                "Reports", 
                "Geofences", 
                "Maintenance", 
                "Admin", 
                "Routes", 
                "Cameras"
            ],
            namesMtto: [
                "Dashboard",
                "Service Log",
                "Error Codes"
            ],
			namesAdmin: [
                "Devices", 
                "Users", 
                "Permissions", 
                "Groups", 
                "Drivers", 
                "Links", 
                "Alerts", 
                "Integrations"
            ],
			namesCamera:[
                "Camera", 
                "Live"
            ]
        }
	},


	es: {
        nav: {
            title: 'Usuarios',
            titleC: "Clientes",
            searchBox: "Buscar cliente",
            dashboard: 'Panel',
            text: "Para visualizar los datos, primero seleccione un mes del menú",
            empty: "No existen dispositivos registrados"
        },
        tabs: [
            'General',
            'Gráficas', 
            'Web', 
            'Dispositivos móviles',
            'Módulos'
        ],
		table: {
            title: ['Conexiones web',"Conexiones móviles"],
            columns: [
                'Fecha',
				'Mexico',
                'USA',
                'Colombia',
                'Total',
            ],
            pager: ['Página', 'de', 'Filas por página'],
            text:["Has llegado a la primera página.","Has llegado a la última página"],
            noDevice: "Sin conexiones registradas"
            
        },
        graphs:{
            line:{
                axis: ["Día","Conexiones"],
            },
            pie:{
                title: ["Dispositivos", "Países"],
                devices: ["Web", "Móviles"],
                countries: ["Mexico","Usa"],
            },
            prefix: ["Día ", " clientes conectados: ", "Dispositivos conectados en  "],
            modal:{
                xlabels: [
                    "Tiempo real",
                    "Histórico",
                    "Reportes",
                    "Geocercas",
                    "Mantenimiento",
                    "Administración",
                    "Rutas",
                    "Cámaras",
                ],
                prefix: [" fue visitado ", " vez ", " por:", " veces"],
                text: "Para visualizar los datos, primero seleccione un cliente del menu lateral",
                axis: ["Vistas frecuentes", "Frecuencia", "Módulos"],
                modalMtto:[
                    "Mantenimiento",
                    "Servicios",
                    "Códigos de error"
                ],
                modalAdmin:[
                    "Dispositivos",
                    "Usuarios",
                    "Permisos",
                    "Grupos",
                    "Conductores",
                    "Links",
                    "Alarmas",
                    "Integraciones"
                ],
                modalCamera:[
                    "Cámaras",
                    "En vivo"
                ],
            }
        },
        sidebar:["Conexiones", "Buscar", "Seleccione un mes", "Debes seleccionar un mes"],
        modal:{
            title: "Detalle de clientes",
            columns: [
                'Clientes',
				'Conexiones',
                'Usuarios',
            ],
        },
        login: {
            username: "Usuario",
            password: "Contraseña",
            button: "Iniciar Sesión"
        },
        auxHcBar:{
            namesGeneral: [
                "Tiempo real", 
                "Histórico", 
                "Reportes", 
                "Geocercas", 
                "Mantenimiento", 
                "Administración", 
                "Rutas", 
                "Cámaras"
            ],
            namesMtto: [
                "Mantenimiento",
                "Servicios",
                "Códigos de Error"
            ],
			namesAdmin: [
                "Dispositivos", 
                "Usuarios", 
                "Permisos", 
                "Grupos", 
                "Conductores", 
                "Links", 
                "Alarmas", 
                "Integraciones"
            ],
			namesCamera:[
                "Cámaras",
                "En vivo"
            ]
        }
	},
}
